<template>
   <aside v-if="ready" class="sidebar z-2 no-shadow nav-sidebar-theme" :class="{ 'licence-expired': $route.path == '/expiredlicence' }" data-role="sidebar" id="main_menu" data-shift=".shifted-content" data-overlay="true" data-static="lg" @click.capture="stopNavigationWhenLicenceExpired" @keydown.enter.capture="stopNavigationWhenLicenceExpired" @keydown.space.capture="stopNavigationWhenLicenceExpired">
      <!-- data-role="html-container" data-html-source="sidenav.html" data-insert-mode="content" data-role-htmlcontainer="true"-->
      <ul class="sidebar-menu w-100">
         <li class="sidebar-brand mt-4">
            <router-link to="/dashboard" class="pl-0" active-class="" exact-active-class="">
               <img src="/assets/img/brand/iperius_one_complete_logo_white.svg" alt="Iperius One">
            </router-link>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Main") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <li>
                  <router-link to="/dashboard">
                     <span class="icon p-0 rounded">
                        <svg style="width: 26;height: 26;" width="26" height="26" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M11.499 9.5 11.5 21H6.25a3.25 3.25 0 0 1-3.245-3.065L3 17.752V9.499h8.499Zm1.5 5.999H21.5v2.253a3.25 3.25 0 0 1-3.25 3.25L13 21l-.001-5.502Zm5.252-13a3.25 3.25 0 0 1 3.245 3.065l.005.184-.001 8.251h-8.501L13 2.498h5.251ZM11.5 2.497 11.499 8H3V5.748a3.25 3.25 0 0 1 3.25-3.25h5.25Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Dashboard") }}</span>
                  </router-link>
               </li>
            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Elements") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <li>
                  <router-link to="/groups">
                     <span class="icon p-0 rounded">
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5Zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25Zm-8.498 8c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 9.752 18h-2a1.75 1.75 0 0 1-1.75-1.75v-2c0-.966.783-1.75 1.75-1.75h2Zm6.497 0c.967 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 16.25 18h-2a1.75 1.75 0 0 1-1.75-1.75v-2c0-.966.784-1.75 1.75-1.75h2ZM9.751 6c.966 0 1.75.784 1.75 1.75v2a1.75 1.75 0 0 1-1.75 1.75h-2A1.75 1.75 0 0 1 6 9.75v-2C6 6.784 6.784 6 7.75 6h2Zm6.497 0c.967 0 1.75.784 1.75 1.75v2a1.75 1.75 0 0 1-1.75 1.75h-2a1.75 1.75 0 0 1-1.75-1.75v-2c0-.966.784-1.75 1.75-1.75h2Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Groups") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/computers">
                     <span class="icon p-0 rounded">
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M6.75 22a.75.75 0 0 1-.102-1.493l.102-.007h1.749v-2.498H4.25a2.25 2.25 0 0 1-2.245-2.096L2 15.752V5.25a2.25 2.25 0 0 1 2.096-2.245L4.25 3h15.499a2.25 2.25 0 0 1 2.245 2.096l.005.154v10.502a2.25 2.25 0 0 1-2.096 2.245l-.154.005h-4.25V20.5h1.751a.75.75 0 0 1 .102 1.494L17.25 22H6.75Zm7.248-3.998h-4l.001 2.498h4l-.001-2.498Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Devices") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/users">
                     <span class="icon p-0 rounded">
                        <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M14.75 15c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297-2.91 0-4.567-1.09-4.567-3.259v-1c0-.966.784-1.75 1.75-1.75h5.5Zm-11-5h4.376a4.007 4.007 0 0 0 1.067 3.85l.162.151L9.25 14a2.75 2.75 0 0 0-2.649 2.008l-.034.001C3.657 16.009 2 14.919 2 12.75v-1c0-.966.784-1.75 1.75-1.75Zm16.5 0c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297l-.169-.002a2.756 2.756 0 0 0-2.451-2L14.75 14l-.105.001a3.99 3.99 0 0 0 1.229-4L20.25 10ZM12 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6.5 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm11 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Users") }}</span>
                  </router-link>
               </li>

            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Backup") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu" id="backupmenu">
               <SidebarItem :locked="$root.noIperiusOneLicense" to="/backupstats" :label="$t('Statistics')">
                  <template #icon>
                     <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.25 4.25A.75.75 0 0 1 11 5v8h8a.75.75 0 0 1 .743.648l.007.102c0 4.97-4.03 8.5-9 8.5a9 9 0 0 1-9-9c0-4.97 3.53-9 8.5-9Zm3-2.5a9 9 0 0 1 9 9 .75.75 0 0 1-.75.75h-8.25a.75.75 0 0 1-.75-.75V2.5a.75.75 0 0 1 .75-.75Z" fill="#f1faff" />
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="$root.noIperiusOneLicense" to="/backups" :label="$t('Backup Jobs')">
                  <template #icon>
                     <svg width="26" height="26" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.019 17H3l-.117.007A1 1 0 0 0 3 19h8.174a6.52 6.52 0 0 1-.155-2ZM21 11H3a1 1 0 0 1-.117-1.993L3 9h18a1 1 0 0 1 .117 1.993L21 11ZM3 15h8.498a6.506 6.506 0 0 1 1.312-2H3l-.117.007A1 1 0 0 0 3 15ZM21 5H3l-.117.007A1 1 0 0 0 3 7h18l.117-.007A1 1 0 0 0 21 5Zm-6.722 8.975-.198-.686c.44-.382.94-.692 1.483-.912l.499.524a2 2 0 0 0 2.899 0l.493-.518a5.278 5.278 0 0 1 1.484.922l-.186.63a2 2 0 0 0 1.45 2.511l.539.13a5.733 5.733 0 0 1 .006 1.808l-.584.144a2 2 0 0 0-1.44 2.496l.197.686c-.439.383-.939.693-1.483.913l-.498-.525a2 2 0 0 0-2.9 0l-.493.518a5.283 5.283 0 0 1-1.484-.921l.187-.631a2 2 0 0 0-1.45-2.51l-.54-.13a5.718 5.718 0 0 1-.006-1.808l.584-.144a2 2 0 0 0 1.441-2.497ZM17.5 19c.8 0 1.45-.672 1.45-1.5 0-.829-.65-1.5-1.45-1.5-.8 0-1.45.671-1.45 1.5 0 .828.65 1.5 1.45 1.5Z" fill="#f1faff" />
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="$root.noIperiusOneLicense" to="/restores" :label="$t('Restore history')">
                  <template #icon>
                     <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.096"></g>
                        <g id="SVGRepo_iconCarrier">
                           <path d="M3 5.67541V3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3V7C1 8.10457 1.89543 9 3 9H7C7.55229 9 8 8.55229 8 8C8 7.44772 7.55229 7 7 7H4.52186C4.54218 6.97505 4.56157 6.94914 4.57995 6.92229C5.621 5.40094 7.11009 4.22911 8.85191 3.57803C10.9074 2.80968 13.173 2.8196 15.2217 3.6059C17.2704 4.3922 18.9608 5.90061 19.9745 7.8469C20.9881 9.79319 21.2549 12.043 20.7247 14.1724C20.1945 16.3018 18.9039 18.1638 17.0959 19.4075C15.288 20.6513 13.0876 21.1909 10.9094 20.9247C8.73119 20.6586 6.72551 19.605 5.27028 17.9625C4.03713 16.5706 3.27139 14.8374 3.06527 13.0055C3.00352 12.4566 2.55674 12.0079 2.00446 12.0084C1.45217 12.0088 0.995668 12.4579 1.04626 13.0078C1.25994 15.3309 2.2082 17.5356 3.76666 19.2946C5.54703 21.3041 8.00084 22.5931 10.6657 22.9188C13.3306 23.2444 16.0226 22.5842 18.2345 21.0626C20.4464 19.541 22.0254 17.263 22.6741 14.6578C23.3228 12.0526 22.9963 9.30013 21.7562 6.91897C20.5161 4.53782 18.448 2.69239 15.9415 1.73041C13.4351 0.768419 10.6633 0.756291 8.14853 1.69631C6.06062 2.47676 4.26953 3.86881 3 5.67541Z" fill="#0F0F0F"></path>
                           <path d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2344 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.546 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z" fill="#0F0F0F"></path>
                        </g>
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="$root.noIperiusOneLicense" to="/accounts" :label="$t('Credentials')">
                  <template #icon>
                     <svg width="26" height="26" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 26px; height: 26px;">
                        <path d="M4.249 13.995h5.876c-.349.423-.574.952-.62 1.53l-.009.22v4.5c0 .665.236 1.275.63 1.75l-.13.001c-3.42 0-5.943-1.072-7.486-3.236A2.75 2.75 0 0 1 2 17.164v-.92a2.249 2.249 0 0 1 2.249-2.249Zm10.497-2.5h3c.648 0 1.18.492 1.244 1.123l.007.127-.001 1.25h1.25c.967 0 1.75.784 1.75 1.75v4.5a1.75 1.75 0 0 1-1.75 1.75h-8a1.75 1.75 0 0 1-1.75-1.75v-4.5c0-.966.784-1.75 1.75-1.75h1.25v-1.25c0-.647.492-1.18 1.123-1.243l.127-.007h3-3Zm2.75 1.5h-2.5v1h2.5v-1ZM9.997 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" fill="#f1faff"></path>
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="$root.noIperiusOneLicense" to="/repo" :label="$t('Repositories')">
                  <template #icon>
                     <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2a4 4 0 0 1 4 4v2h2.5A1.5 1.5 0 0 1 18 9.5V11c-.319 0-.637.11-.896.329l-.107.1c-.812.845-1.656 1.238-2.597 1.238-.783 0-1.4.643-1.4 1.416v2.501c0 2.374.924 4.22 2.68 5.418L3.5 22A1.5 1.5 0 0 1 2 20.5v-11A1.5 1.5 0 0 1 3.5 8H6V6a4 4 0 0 1 4-4Zm8.284 10.122c.992 1.036 2.091 1.545 3.316 1.545.193 0 .355.143.392.332l.008.084v2.501c0 2.682-1.313 4.506-3.873 5.395a.385.385 0 0 1-.253 0c-2.476-.86-3.785-2.592-3.87-5.13L14 16.585v-2.5c0-.23.18-.417.4-.417 1.223 0 2.323-.51 3.318-1.545a.389.389 0 0 1 .566 0ZM10 13.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM10 4a2 2 0 0 0-2 2v2h4V6a2 2 0 0 0-2-2Z" fill="#f1faff"></path>
                     </svg>
                  </template>
               </SidebarItem>
            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Remote Access") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <li>
                  <router-link to="/remotestats">
                     <span class="icon p-0">
                        <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M10.25 4.25A.75.75 0 0 1 11 5v8h8a.75.75 0 0 1 .743.648l.007.102c0 4.97-4.03 8.5-9 8.5a9 9 0 0 1-9-9c0-4.97 3.53-9 8.5-9Zm3-2.5a9 9 0 0 1 9 9 .75.75 0 0 1-.75.75h-8.25a.75.75 0 0 1-.75-.75V2.5a.75.75 0 0 1 .75-.75Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Statistics") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/sessions" active-class="active">
                     <span class="icon p-0 ">
                        <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="M4.25 4A2.25 2.25 0 0 0 2 6.25v2.5A2.25 2.25 0 0 0 4.25 11h2.5A2.25 2.25 0 0 0 9 8.75v-2.5A2.25 2.25 0 0 0 6.75 4h-2.5Zm7 1a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-10Zm0 3a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm-7 5A2.25 2.25 0 0 0 2 15.25v2.5A2.25 2.25 0 0 0 4.25 20h2.5A2.25 2.25 0 0 0 9 17.75v-2.5A2.25 2.25 0 0 0 6.75 13h-2.5Zm7 1a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-10Zm0 3a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("sessions") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/activesessions">
                     <span class="icon p-0 ">
                        <svg style="width: 26;height: 26;" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="m15.207 2.292 4 3.995a1 1 0 0 1 .084 1.32l-.083.094-4 4.006a1 1 0 0 1-1.498-1.32l.083-.094L16.083 8H5.5a1 1 0 0 1-.994-.883L4.5 7a1 1 0 0 1 .883-.993L5.5 6h10.59l-2.296-2.293a1 1 0 0 1-.084-1.32l.083-.095a1 1 0 0 1 1.32-.084l.094.084 4 3.995-4-3.995Zm4.283 14.591.007.117a1 1 0 0 1-.883.993l-.117.007H7.913l2.294 2.293a1 1 0 0 1 .084 1.32l-.083.094a1 1 0 0 1-1.32.084l-.095-.084-4-3.996a1 1 0 0 1-.083-1.32l.083-.094 4-4.004a1 1 0 0 1 1.498 1.32l-.083.094L7.918 16h10.579a1 1 0 0 1 .993.883l.007.117-.007-.117Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Active sessions") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/customclient">
                     <span class="icon p-0 ">
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path d="m17.75 3 .184.005a3.25 3.25 0 0 1 3.062 3.06l.005.185v11.5l-.005.184a3.25 3.25 0 0 1-3.06 3.06L17.75 21H6.25a3.25 3.25 0 0 1-3.245-3.066L3 17.75V6.25a3.25 3.25 0 0 1 3.066-3.245L6.25 3h11.5ZM19 8H5.001L5 17.75c0 .647.492 1.18 1.122 1.244L6.25 19h11.501l.128-.006a1.25 1.25 0 0 0 1.116-1.116L19 17.75 19 8Zm-8.75 1.5a.75.75 0 0 1 .743.648l.007.102v7a.75.75 0 0 1-.648.743L10.25 18h-3.5a.75.75 0 0 1-.743-.648L6 17.25v-7a.75.75 0 0 1 .648-.743L6.75 9.5h3.5ZM9.5 11h-2v5.5h2V11Zm6.75 1.503a.75.75 0 0 1 .102 1.493l-.102.007h-3.496a.75.75 0 0 1-.101-1.493l.101-.007h3.496Zm1-3.003a.75.75 0 0 1 .102 1.493L17.25 11h-4.496a.75.75 0 0 1-.101-1.493l.101-.007h4.496Z" fill="#f1faff" />
                        </svg>
                     </span>
                     <span>{{ $t("Custom client") }}</span>
                  </router-link>
               </li>
            </ul>
         </li>

         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Management") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <SidebarItem :locked="$root.noIperiusOneLicensePolicies" to="/policies" :label="$t('Policies')">
                  <template #icon>
                     <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.5 20.002a.5.5 0 0 1-.5.5H9v1.5h9a2 2 0 0 0 2-2V9.83c0-.53-.211-1.04-.586-1.414l-5.829-5.829a.49.49 0 0 0-.049-.04.63.63 0 0 1-.036-.03 2.072 2.072 0 0 0-.219-.18.65.65 0 0 0-.08-.044c-.017-.008-.033-.015-.048-.024l-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 0 0-.624-.138c-.02-.001-.04-.004-.059-.007A.605.605 0 0 0 12.172 2H6a2 2 0 0 0-2 2v7.257a4.49 4.49 0 0 1 1.5-.256v-7a.5.5 0 0 1 .5-.5h6V8a2 2 0 0 0 2 2h4.5v10.001Zm-5-15.38L17.378 8.5H14a.5.5 0 0 1-.5-.5V4.62ZM9 15.501a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-6 3.742v3.044a.71.71 0 0 0 1.212.503L5.5 21.503l1.288 1.288A.71.71 0 0 0 8 22.288v-3.044a4.479 4.479 0 0 1-2.5.758c-.925 0-1.785-.279-2.5-.758Z" fill="#222F3D" />
                     </svg>
                  </template>
               </SidebarItem>
            </ul>
         </li>

         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Script") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <li>
                  <router-link to="/scripts/inventory">
                     <span class="icon p-0 ">
                        <svg width="24" height="24" fill="none" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                           <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                           <g id="SVGRepo_iconCarrier">
                              <path fill="#222F3D" d="M919.113143 325.485714H104.813714v-67.803428h814.299429v-133.12a36.571429 36.571429 0 0 0-36.571429-36.571429H141.385143a36.571429 36.571429 0 0 0-36.571429 36.571429L103.862857 865.645714a36.425143 36.425143 0 0 0 36.571429 36.571429h673.865143a33.938286 33.938286 0 1 1 0 67.876571h-705.097143-0.146286a73.142857 73.142857 0 0 1-73.069714-73.142857L36.937143 93.184a73.142857 73.142857 0 0 1 73.142857-73.142857h803.693714a73.142857 73.142857 0 0 1 73.142857 73.142857v703.268571a33.938286 33.938286 0 0 1-67.803428 0V325.485714zM206.628571 215.844571a33.938286 33.938286 0 1 1 0-67.803428 33.938286 33.938286 0 0 1 0 67.803428z m203.556572 0a33.938286 33.938286 0 1 1 0-67.803428 33.938286 33.938286 0 0 1 0 67.803428z m-101.814857 0a33.938286 33.938286 0 1 1 0-67.803428 33.938286 33.938286 0 0 1 0 67.803428z m34.889143 250.148572c7.168-7.094857 26.112-7.094857 33.28 0 7.168 7.094857 7.168 29.476571 0 37.156571L265.874286 610.742857 373.76 712.923429c7.168 7.094857 8.118857 27.355429 0 35.328-9.801143 9.728-29.842286 8.192-36.571429 1.609142l-126.025142-125.805714a18.432 18.432 0 0 1 0-25.965714l132.096-132.096z m343.478857 0l132.096 132.096a18.432 18.432 0 0 1 0 26.038857l-126.098286 125.732571c-6.656 6.582857-25.6 10.752-36.571429 0-10.313143-10.24-7.094857-31.305143 0-38.4l108.397715-100.717714-111.908572-108.690286c-7.168-7.68-9.508571-26.624 0-36.059428 9.289143-9.142857 26.916571-7.094857 34.084572 0z m-135.68-26.331429c3.657143-9.508571 21.430857-15.506286 32.768-11.264 10.825143 4.022857 17.188571 19.017143 14.189714 28.525715l-119.808 329.947428c-3.657143 9.508571-20.699429 13.238857-30.281143 9.728-10.166857-3.584-21.211429-17.554286-17.554286-27.062857l120.685715-329.874286z"></path>
                           </g>
                        </svg>
                     </span>
                     <span>{{ $t("Scripts inventory") }}</span>
                  </router-link>
               </li>
               <li>
                  <router-link to="/scripts/history">
                     <span class="icon p-0">
                        <svg class="deploy-history-menu-icon" width="26" height="26" viewBox="110 170 820 680" fill="none" xmlns="http://www.w3.org/2000/svg">

                           <!-- Finestra browser -->
                           <path fill="#000000" fill-rule="evenodd" clip-rule="evenodd" d="
        M208 224
        H682
        C721 224 753 256 753 295
        V421
        L716 444
        V325
        H180
        V621
        C180 640 195 655 214 655
        H554
        L520 692
        H208
        C173 692 144 663 144 628
        V288
        C144 253 173 224 208 224
        Z

        M180 288
        H716
        V276
        C716 268 709 261 701 261
        H195
        C187 261 180 268 180 276
        V288
        Z" />

                           <!-- Pallini barra superiore -->
                           <circle cx="215" cy="275" r="17" fill="#000000" />
                           <circle cx="271" cy="275" r="17" fill="#000000" />
                           <circle cx="327" cy="275" r="17" fill="#000000" />

                           <!-- Simbolo codice -->
                           <path d="M359 405L258 470L359 536" stroke="#000000" stroke-width="39" stroke-linecap="round" stroke-linejoin="round" />

                           <path d="M464 389L401 545" stroke="#000000" stroke-width="42" stroke-linecap="round" />

                           <path d="M525 405L617 470L525 536" stroke="#000000" stroke-width="39" stroke-linecap="round" stroke-linejoin="round" />

                           <!-- Razzo: corpo principale -->
                           <path fill="#000000" d="
        M650 522
        C703 468 769 433 843 416
        C860 412 878 410 884 416
        C891 423 890 441 888 458
        C879 527 847 598 793 650
        L669 713
        L585 629
        L650 522
        Z" />

                           <!-- Punta / fianco superiore del razzo -->
                           <path fill="#000000" d="
        M650 522
        C705 467 773 431 845 415
        C864 411 882 411 888 417
        C893 423 891 443 889 459
        C882 523 850 593 794 649
        L650 522
        Z" />

                           <!-- Pinna sinistra -->
                           <path fill="#000000" d="
        M650 522
        C603 518 559 544 528 584
        C521 593 516 603 524 616
        L612 605
        L674 544
        L650 522
        Z" />

                           <!-- Pinna destra -->
                           <path fill="#000000" d="
        M793 650
        C797 699 775 741 733 766
        C720 774 684 789 686 761
        L694 676
        L770 621
        L793 650
        Z" />

                           <!-- Collegamento centrale -->
                           <path fill="#000000" d="
        M583 626
        L670 713
        L644 739
        L557 652
        Z" />

                           <!-- Fiamma grande -->
                           <path fill="#000000" d="
        M588 675
        C551 708 525 746 512 781
        C547 772 580 754 603 730
        C595 747 587 761 578 773
        C608 764 633 745 645 718
        L604 677
        Z" />

                           <!-- Fiamma piccola superiore -->
                           <path fill="#000000" d="
        M568 648
        C549 667 534 693 525 723
        L584 680
        L568 648
        Z" />

                           <!-- Oblò -->
                           <circle cx="785" cy="515" r="46" fill="#000000" />

                           <circle cx="785" cy="515" r="29" fill="white" />
                        </svg>
                     </span>
                     <span>{{ $t("Deploy history") }}</span>
                  </router-link>
               </li>
            </ul>

         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Ticketing") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <SidebarItem :locked="!$root.ticketingEnabled" to="/tickets" :label="$t('Tickets')">
                  <template #icon>
                     <svg fill="#f1faff" height="24" width="24" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                           <g>
                              <g>
                                 <path d="M403.234,395.844c-13.611-5.956-29.056-12.689-46.626-20.736l-0.794-0.358l-0.623,0.606 c-5.879,5.709-12.39,11.11-19.371,16.06l-1.792,1.263l1.988,0.93c22.067,10.257,41.182,18.662,57.353,25.737 c59.998,26.18,67.576,31.292,67.576,45.559c0,9.796-9.66,21.641-21.641,21.641H72.687c-11.981,0-21.641-11.844-21.641-21.641 c0-14.268,7.586-19.379,67.576-45.559c16.171-7.074,35.294-15.479,57.353-25.737l1.988-0.93l-1.792-1.263 c-6.972-4.949-13.491-10.359-19.371-16.06l-0.623-0.606l-0.794,0.358c-17.579,8.038-33.016,14.78-46.626,20.736 C48.239,422.263,25.6,432.154,25.6,464.913C25.6,489.557,48.043,512,72.687,512h366.626c24.644,0,47.087-22.443,47.087-47.087 C486.4,432.154,463.761,422.263,403.234,395.844z"></path>
                              </g>
                           </g>
                           <g>
                              <g>
                                 <path d="M435.2,153.6h-25.6C409.6,68.77,340.83,0,256,0S102.4,68.77,102.4,153.6H76.8c-14.14,0-25.6,11.46-25.6,25.6V256 c0,14.14,11.46,25.6,25.6,25.6h25.6c7.56,0,14.174-3.422,18.867-8.627c0.777,1.101,1.468,2.219,2.389,3.285 C141.38,346.411,193.997,397.432,256,397.432c63.505,0,117.052-53.572,133.461-126.353c4.668,6.229,11.759,10.522,20.139,10.522 h25.6c14.14,0,25.6-11.46,25.6-25.6v-76.8C460.8,165.06,449.34,153.6,435.2,153.6z M102.4,256H76.8v-76.8h25.6V256z M256,371.985 c-41.412,0-77.611-29.21-97.374-72.559C188.962,312.627,228.727,320,256,320c7.074,0,12.8-5.726,12.8-12.8s-5.726-12.8-12.8-12.8 c-45.005,0-92.996-17.988-109.107-30.822c-2.654-12.527-4.19-25.651-4.19-39.262c0-81.425,50.833-147.669,113.297-147.669 s113.297,66.244,113.297,147.669S318.464,371.985,256,371.985z M383.693,156.655C362.53,94.729,313.267,51.2,256,51.2 c-57.267,0-106.53,43.529-127.693,105.455c-0.026-1.041-0.307-2.014-0.307-3.055c0-70.579,57.421-128,128-128s128,57.421,128,128 C384,154.641,383.718,155.614,383.693,156.655z M435.2,256h-25.6v-76.8h25.6V256z"></path>
                              </g>
                           </g>
                        </g>
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="!$root.ticketingEnabled" to="/teams" :label="$t('Teams')">
                  <template #icon>
                     <svg fill="#f1faff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 478.676 478.676" xml:space="preserve">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                           <g>
                              <g>
                                 <g>
                                    <path d="M361.275,312.934l-68.872-27.462l-16.13-13.587c-4.261-3.601-10.552-3.336-14.5,0.595l-22.422,22.296l-22.487-22.307 c-3.954-3.92-10.236-4.174-14.493-0.584l-16.127,13.587l-68.877,27.467c-22.177,8.831-22.159,87.371-24.063,94.58h292.068 C383.472,400.327,383.462,321.757,361.275,312.934z"></path>
                                    <path d="M160.47,201.105l12.934-0.033c7.99,41.744,36.343,65.492,65.935,65.492s46.785-14.063,58.188-39.991 c-8.707,6.828-21.356,13.074-39.054,14.363c-1.626,2.423-4.39,4.018-7.524,4.018h-8.27c-5.003,0-9.06-4.056-9.06-9.061 c0-5.004,4.057-9.06,9.06-9.06h8.27c2.931,0,5.528,1.397,7.185,3.556c28.45-2.284,41.829-19.538,47.164-29.28l12.913-0.004 c7.906,0,14.314-6.413,14.314-14.317v-32.45c0-5.067-2.643-9.511-6.613-12.056c-4.784-39.943-41.78-71.125-86.571-71.125 s-81.787,31.182-86.57,71.125c-3.974,2.545-6.614,6.988-6.614,12.056v32.449C146.153,194.692,152.563,201.105,160.47,201.105z M239.338,87.384c35.253,0,64.573,23.249,69.979,53.579c-1.688,0.642-3.222,1.589-4.534,2.781 c-8.443-26.654-32.836-42.499-65.443-42.499c-32.608,0-57.016,15.834-65.468,42.478c-1.308-1.182-2.832-2.123-4.51-2.76 C174.765,110.633,204.085,87.384,239.338,87.384z"></path>
                                    <path d="M463.158,322.283l-44.351-17.683l-10.387-8.749c-2.742-2.318-6.793-2.147-9.337,0.382l-14.438,14.356l-14.479-14.362 c-2.546-2.523-6.592-2.688-9.332-0.376l-4.947,4.168l9.091,3.624c19.589,7.789,25.386,43.547,28.364,79.547h85.333 C477.453,378.561,477.446,327.966,463.158,322.283z"></path>
                                    <path d="M324.636,220.159v20.896c0,5.091,4.127,9.22,9.22,9.22l8.327-0.021c5.146,26.879,23.402,42.172,42.457,42.172 c19.057,0,30.126-9.057,37.469-25.75c-5.604,4.396-13.753,8.418-25.146,9.248c-1.047,1.562-2.826,2.588-4.847,2.588h-5.323 c-3.222,0-5.834-2.611-5.834-5.834s2.612-5.834,5.834-5.834h5.323c1.888,0,3.561,0.899,4.627,2.289 c18.317-1.471,26.935-12.582,30.37-18.854l8.312-0.003c5.092,0,9.219-4.129,9.219-9.22v-20.895c0-3.263-1.699-6.124-4.26-7.763 c-3.079-25.721-26.901-45.8-55.745-45.8c-28.842,0-52.665,20.079-55.745,45.8C326.336,214.035,324.636,216.897,324.636,220.159z M384.64,177.046c22.7,0,41.581,14.971,45.062,34.501c-1.087,0.414-2.074,1.024-2.92,1.792 c-5.438-17.164-21.146-27.367-42.143-27.367s-36.714,10.196-42.154,27.353c-0.845-0.761-1.824-1.367-2.904-1.777 C343.059,192.016,361.939,177.046,384.64,177.046z"></path>
                                    <path d="M113.667,303.647l9.099-3.628l-4.947-4.167c-2.742-2.318-6.793-2.148-9.337,0.382L94.044,310.59l-14.48-14.361 c-2.546-2.524-6.592-2.688-9.332-0.376l-10.386,8.749l-44.351,17.687C1.215,327.975,1.225,378.55,0,383.19h85.328 C88.298,347.2,94.081,311.446,113.667,303.647z"></path>
                                    <path d="M43.25,250.274l8.328-0.021c5.146,26.881,23.403,42.174,42.458,42.174c19.055,0,30.126-9.057,37.468-25.752 c-5.606,4.396-13.753,8.418-25.147,9.25c-1.047,1.561-2.826,2.586-4.846,2.586h-5.324c-3.222,0-5.833-2.61-5.833-5.834 c0-3.221,2.611-5.834,5.833-5.834h5.324c1.887,0,3.56,0.9,4.626,2.291c18.32-1.471,26.936-12.582,30.371-18.854l8.314-0.003 c5.091,0,9.218-4.129,9.218-9.219v-20.896c0-3.263-1.7-6.124-4.259-7.763c-3.08-25.721-26.903-45.8-55.745-45.8 c-28.843,0-52.666,20.079-55.745,45.8c-2.56,1.639-4.26,4.5-4.26,7.763v20.895C34.031,246.146,38.158,250.274,43.25,250.274z M94.036,177.046c22.7,0,41.58,14.971,45.061,34.501c-1.088,0.414-2.074,1.024-2.92,1.792 c-5.437-17.164-21.144-27.367-42.141-27.367c-20.998,0-36.714,10.196-42.157,27.353c-0.842-0.761-1.823-1.367-2.903-1.777 C52.455,192.016,71.336,177.046,94.036,177.046z"></path>
                                 </g>
                              </g>
                           </g>
                        </g>
                     </svg>
                  </template>
               </SidebarItem>
            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Billing") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <SidebarItem :locked="!$root.ticketingEnabled" to="/billing/clients" :label="$t('Customers')">
                  <template #icon>
                     <svg width="24" height="24" viewBox="0 0 16 16" fill="#f1faff" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 3.5C8 4.88071 6.88071 6 5.5 6C4.11929 6 3 4.88071 3 3.5C3 2.11929 4.11929 1 5.5 1C6.88071 1 8 2.11929 8 3.5Z" />
                        <path d="M3 8C1.34315 8 0 9.34315 0 11V15H8V8H3Z" />
                        <path d="M13 8H10V15H16V11C16 9.34315 14.6569 8 13 8Z" />
                        <path d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z" />
                     </svg>
                  </template>
               </SidebarItem>
               <SidebarItem :locked="!$root.ticketingEnabled" to="/billing/invoices" :label="$t('Invoices')">
                  <template #icon>
                     <span class="mif-file-text" style="font-size:24px"></span>
                  </template>
               </SidebarItem>
            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Logs") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">

               <li>
                  <router-link to="/auditlogs">
                     <img class="icon p-0" src="data:image/svg+xml;base64,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" width="24" height="24">
                     <span>{{ $t("Audit logs") }}</span>
                  </router-link>
               </li>
               <!-- <li>
               <a class="dropdown-toggle m-0" href="#" @click="subMenuOpen= (subMenuOpen!='settings'?'settings':'')"
                   @blur="subMenuOpen =''">
                   <span class="icon p-0 ">
                       <svg width="24" height="24" fill="none" viewBox="0 0 24 24"
                           xmlns="http://www.w3.org/2000/svg">
                           <path
                               d="M12.012 2.25c.734.008 1.465.093 2.182.253a.75.75 0 0 1 .582.649l.17 1.527a1.384 1.384 0 0 0 1.927 1.116l1.401-.615a.75.75 0 0 1 .85.174 9.792 9.792 0 0 1 2.204 3.792.75.75 0 0 1-.271.825l-1.242.916a1.381 1.381 0 0 0 0 2.226l1.243.915a.75.75 0 0 1 .272.826 9.797 9.797 0 0 1-2.204 3.792.75.75 0 0 1-.848.175l-1.407-.617a1.38 1.38 0 0 0-1.926 1.114l-.169 1.526a.75.75 0 0 1-.572.647 9.518 9.518 0 0 1-4.406 0 .75.75 0 0 1-.572-.647l-.168-1.524a1.382 1.382 0 0 0-1.926-1.11l-1.406.616a.75.75 0 0 1-.849-.175 9.798 9.798 0 0 1-2.204-3.796.75.75 0 0 1 .272-.826l1.243-.916a1.38 1.38 0 0 0 0-2.226l-1.243-.914a.75.75 0 0 1-.271-.826 9.793 9.793 0 0 1 2.204-3.792.75.75 0 0 1 .85-.174l1.4.615a1.387 1.387 0 0 0 1.93-1.118l.17-1.526a.75.75 0 0 1 .583-.65c.717-.159 1.45-.243 2.201-.252ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
                               fill="#f1faff" />
                       </svg>
                   </span>
                   <span>{{ $t("Settings") }}</span>
                   <span class="arrow" :class="{'open': subMenuOpen == 'settings'}"></span>
               </a>
               <ul class="d-menu no-shadow" data-role="dropdown">
                   <li>
                       <router-link to="/settings">
                           <span class="icon p-0 pl-5">
                               <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 13h9.309A6.478 6.478 0 0 0 11 17.5c0 1.087.267 2.112.739 3.013-1.05.35-2.208.487-3.239.487-2.722 0-6.335-.956-6.495-4.27L2 16.5v-2a1.5 1.5 0 0 1 1.356-1.493L3.5 13ZM21 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM8.5 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm5.777 11.975a2 2 0 0 1-1.441 2.497l-.584.144a5.729 5.729 0 0 0 .006 1.807l.54.13a2 2 0 0 1 1.45 2.51l-.187.632c.44.386.94.699 1.485.921l.493-.518a2 2 0 0 1 2.899 0l.499.525a5.282 5.282 0 0 0 1.482-.913l-.198-.686a2 2 0 0 1 1.442-2.496l.583-.144a5.729 5.729 0 0 0-.006-1.808l-.54-.13a2 2 0 0 1-1.449-2.51l.186-.63a5.278 5.278 0 0 0-1.484-.923l-.493.519a2 2 0 0 1-2.9 0l-.498-.525c-.544.22-1.044.53-1.483.912l.198.686ZM17.5 19c-.8 0-1.45-.672-1.45-1.5 0-.829.65-1.5 1.45-1.5.8 0 1.45.671 1.45 1.5 0 .828-.65 1.5-1.45 1.5Z" fill="#f1faff"/></svg>
                           </span>
                           <span class="pl-5">{{ $t("Privacy Settings") }}</span>
                       </router-link>
                   </li>
               
               </ul>
               </li> -->
            </ul>
         </li>
         <li class="nav-section">
            <div class="nav-section-title">
               <span>{{ $t("Support") }}</span>
            </div>
            <ul class="no-shadow nav-section-menu">
               <li>
                  <a :href="contactUrl" target="_blank" rel="noopener noreferrer" :title="$t('Contact us')">
                     <span class="icon mif-phone mif-2x"></span>
                     <span>{{ $t('Contact us') }}</span>
                  </a>
               </li>
            </ul>
         </li>
      </ul>
   </aside>
</template>

<script>
import SidebarItem from '../components/utils/SidebarItem.vue';
import { waitSeconds } from '../utils/utilitiesmodule.js';

export default {
   name: 'Sidebar',
   components: { SidebarItem },
   data() {
      return {
         ready: false,
         licenceIsValid: true,
         contactUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'en/contact/'

      }
   },

   async created() {
      for (var s = 1; s <= 10; s++) {
         if (!this.$root.authObj) {
            await waitSeconds(1);
         } else {
            break;
         }
      }
      this.licenceIsValid = this.$root.authObj && !this.$root.authObj.licenceExpired;
      this.ready = true;

   },

   methods: {
      stopNavigationWhenLicenceExpired(event) {
         if (!this.$root.authObj || this.licenceIsValid) {
            return;
         }

         const navItem = event.target.closest('a, button');
         if (!navItem || navItem.closest('.sidebar-brand')) {
            return;
         }

         event.preventDefault();
         event.stopPropagation();
      }
   }
}
</script>

<style scoped>
.deploy-history-menu-icon {
   display: block;
   width: 26px;
   height: 26px;
}

.deploy-history-menu-icon [fill="#000000"] {
   fill: #222F3D;
}

.deploy-history-menu-icon [stroke="#000000"] {
   stroke: #222F3D;
}
</style>
